import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import purpleX from "../../assets/images/buttonIcons/purpleX.png";
import { sendVagonMessage } from "../vagon/helpers/utils";
import * as constants from "../../constants";
import Modal from "../../pages/console/components/Modal";
import Typography from "../../components/common/text/Typography";
import Button from "../../components/common/button/Button";
import { getRoomGames } from "../../pages/console/admin/rooms/api/roomController";
import Banner from "../../components/layout/ui/Banner";
import { sendSocketMessage } from "../../socket";

const staticGames = ["https://freegames.org/blackjack", "https://www.247freepoker.com", "https://www.247roulette.org"];

const LionGamingCasino = (props) => {
    const roomSettings = JSON.parse(localStorage.getItem("roomSettings")) || {};
    const email = useSelector((state) => state?.user?.email);
    const [modalOpen, setModalOpen] = useState(false);
    const [errorBanner, setErrorBanner] = useState("");
    const [url, setUrl] = useState(null);
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const modalMessage = useRef();

    const fetchGames = async () => {
        if (!roomSettings?.roomId) return;
        try {
            const response = await getRoomGames(roomSettings.roomId);
            setGames(response || []);
        } catch (err) {
            console.error("Error fetching games:", err);
            setErrorBanner("Unable to load games. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const fetchUrl = async () => {
        try {
            const params = props.data.split("&").reduce((acc, param) => {
                const [key, value] = param.split("=");
                acc[key] = value;
                return acc;
            }, {});

            const liongame = params.liongame;
            if (games?.length > 0) {
                const match = games.find((g) => String(g.slotNumber) === liongame);
                if (match?.url) {
                    setUrl(match.url);
                }
            }
        } catch (error) {
            console.error("Error fetching url:", error);
            setUrl("https://jackpot.onelink.me/1833068633/2ti29w3k");
        }
    };

    useEffect(() => {
        (async () => {
            await fetchGames();
        })();
    }, []);

    useEffect(() => {
        if (games?.length > 0) {
            fetchUrl();
        }
    }, [props.data, games]);

    const updateModal = () => setModalOpen((prev) => !prev);

    useEffect(() => {
        async function handleMessage(event) {
            if (event.data.messageType === "closeGame") {
                modalMessage.current = event.data?.messageData?.message || "An error occurred. Please try again later.";
                updateModal();
            }
        }

        window.addEventListener("message", handleMessage);

        // Cleanup function
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    return (
        <div>
            <Banner
                width={"100%"}
                zIndex="1000"
                message={`${errorBanner}`}
                type={"ERROR"}
                openBanner={!!errorBanner}
                setOpenBanner={setErrorBanner}
                topDisplay
                showCloseButton
                gameScreen
                timer={8000}
                top={"0px"}
                left={"0"}
            />
            <Modal
                isOpen={modalOpen}
                setIsOpen={setModalOpen}
                children={
                    <>
                        <Typography variant="pWhite" margin={"30px 0"}>
                            {modalMessage.current}
                        </Typography>
                        <Button
                            margin={"15px 0px 0px 0px"}
                            label="Okay"
                            height={"30px"}
                            variant="OutlinedButton"
                            onClick={() => {
                                const isDCVPlay = localStorage.getItem("isDCVPlay");
                                if (isDCVPlay === "true") {
                                    sendSocketMessage(
                                        "system_message",
                                        "",
                                        "",
                                        "",
                                        constants.UNITY_CLOSE_WEB_INTERFACE
                                    );
                                } else {
                                    sendVagonMessage(constants.UNITY_CLOSE_WEB_INTERFACE);
                                }
                                props.setLionGamingSlot(null);
                                modalMessage.current = false;
                            }}
                            buttonWidth="100%"
                            fontSize="20px"
                        />
                    </>
                }
                closeButton={false}
            />
            {!loading && url && (
                <>
                    <iframe
                        title="Lion Gaming Iframe Content"
                        id="splash"
                        scrolling="no"
                        allow="autoplay"
                        style={{
                            position: "absolute",
                            overflow: "hidden",
                            width: "100%",
                            height: "100%",
                            display: "block",
                            padding: 0,
                            border: 0,
                            zIndex: 9998,
                            top: 0,
                            left: 0,
                        }}
                        src={url}
                    />

                    <CloseButton
                        type="button"
                        onClick={() => {
                            const isDCVPlay = localStorage.getItem("isDCVPlay");
                            if (isDCVPlay === "true") {
                                sendSocketMessage("system_message", "", "", "", constants.UNITY_CLOSE_WEB_INTERFACE);
                            } else {
                                sendVagonMessage(constants.UNITY_CLOSE_WEB_INTERFACE);
                            }
                            props.setLionGamingSlot(null);
                        }}
                    >
                        <StyledImage src={purpleX} alt="Close" />
                    </CloseButton>
                </>
            )}
        </div>
    );
};

export default LionGamingCasino;

const StyledImage = styled.img`
    @media (max-width: 960px) {
        width: 30px;
        height: auto;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    z-index: 9999;
    top: 45px;
    right: 25px;
    border: none;
    background: transparent;
    cursor: pointer;

    @media (max-width: 960px) {
        top: 40px;
        right: 15px;
    }
`;
